export const GET_PARTNER_INFO_START = "GET_PARTNER_INFO_START";
export const GET_PARTNER_INFO_SUCCESS = "GET_PARTNER_INFO_SUCCESS";
export const GET_PARTNER_INFO_FAIL = "GET_PARTNER_INFO_FAIL";

export const GET_PROMOTION_INFO_START = "GET_PROMOTION_INFO_START";
export const GET_PROMOTION_INFO_SUCCESS = "GET_PROMOTION_INFO_SUCCESS";
export const GET_PROMOTION_INFO_FAIL = "GET_PROMOTION_INFO_FAIL";

export const GET_PARTNERS_START = "GET_PARTNERS_START";
export const GET_PARTNERS_SUCCESS = "GET_PARTNERS_SUCCESS";
export const GET_PARTNERS_FAIL = "GET_PARTNERS_FAIL";

export const GET_CITIES_START = "GET_CITIES_START";
export const GET_CITIES_SUCCESS = "GET_CITIES_SUCCESS";
export const GET_CITIES_FAIL = "GET_CITIES_FAIL";

export const GET_PROMOTIONS_START = "GET_PROMOTIONS_START";
export const GET_PROMOTIONS_SUCCESS = "GET_PROMOTIONS_SUCCESS";
export const GET_PROMOTIONS_FAIL = "GET_PROMOTIONS_FAIL";

export const GET_PROMOCODES_START = "GET_PROMOCODES_START";
export const GET_PROMOCODES_SUCCESS = "GET_PROMOCODES_SUCCESS";
export const GET_PROMOCODES_FAIL = "GET_PROMOCODES_FAIL";

export const GET_SUBSCRIBERS_LIST_START = "GET_SUBSCRIBERS_LIST_START";
export const GET_SUBSCRIBERS_LIST_SUCCESS = "GET_SUBSCRIBERS_LIST_SUCCESS";
export const GET_SUBSCRIBERS_LIST_FAIL = "GET_SUBSCRIBERS_LIST_FAIL";

export const GET_PARTNERS_LIST_START = "GET_PARTNERS_LIST_START";
export const GET_PARTNERS_LIST_SUCCESS = "GET_PARTNERS_LIST_SUCCESS";
export const GET_PARTNERS_LIST_FAIL = "GET_PARTNERS_LIST_FAIL";

export const POST_CREATE_PARTNER_START = "POST_CREATE_PARTNER_START";
export const POST_CREATE_PARTNER_SUCCESS = "POST_CREATE_PARTNER_SUCCESS";
export const POST_CREATE_PARTNER_FAIL = "POST_CREATE_PARTNER_FAIL";

export const UPDATE_PARTNER_START = "UPDATE_PARTNER_START";
export const UPDATE_PARTNER_SUCCESS = "UPDATE_PARTNER_SUCCESS";
export const UPDATE_PARTNER_FAIL = "UPDATE_PARTNER_FAIL";

export const DELETE_PARTNER_START = "DELETE_PARTNER_START";
export const DELETE_PARTNER_SUCCESS = "DELETE_PARTNER_SUCCESS";
export const DELETE_PARTNER_FAIL = "DELETE_PARTNER_FAIL";

export const GET_CMS_START = "GET_CMS_START";
export const GET_CMS_SUCCESS = "GET_CMS_SUCCESS";
export const GET_CMS_FAIL = "GET_CMS_FAIL";

export const CREATE_PROMOTION_START = "CREATE_PROMOTION_START";
export const CREATE_PROMOTION_SUCCESS = "CREATE_PROMOTION_SUCCESS";
export const CREATE_PROMOTION_FAIL = "CREATE_PROMOTION_FAIL";

export const UPDATE_PROMOTION_START = "UPDATE_PROMOTION_START";
export const UPDATE_PROMOTION_SUCCESS = "UPDATE_PROMOTION_SUCCESS";
export const UPDATE_PROMOTION_FAIL = "UPDATE_PROMOTION_FAIL";

export const UPLOAD_CUSTOMER_FILE_START = "UPLOAD_CUSTOMER_FILE_START";
export const UPLOAD_CUSTOMER_FILE_SUCCESS = "UPLOAD_CUSTOMER_FILE_SUCCESS";
export const UPLOAD_CUSTOMER_FILE_FAIL = "UPLOAD_CUSTOMER_FILE_FAIL";

export const DELETE_CUSTOMER_FILE_START = "DELETE_CUSTOMER_FILE_START";
export const DELETE_CUSTOMER_FILE_SUCCESS = "DELETE_CUSTOMER_FILE_SUCCESS";
export const DELETE_CUSTOMER_FILE_FAIL = "DELETE_CUSTOMER_FILE_FAIL";

export const UPLOAD_PROMO_FILE_START = "UPLOAD_PROMO_FILE_START";
export const UPLOAD_PROMO_FILE_SUCCESS = "UPLOAD_PROMO_FILE_SUCCESS";
export const UPLOAD_PROMO_FILE_FAIL = "UPLOAD_PROMO_FILE_FAIL";

export const DELETE_PROMO_FILE_START = "DELETE_PROMO_FILE_START";
export const DELETE_PROMO_FILE_SUCCESS = "DELETE_PROMO_FILE_SUCCESS";
export const DELETE_PROMO_FILE_FAIL = "DELETE_PROMO_FILE_FAIL";

export const GET_CUSTOMER_FILES_START = "GET_CUSTOMER_FILES_START";
export const GET_CUSTOMER_FILES_SUCCESS = "GET_CUSTOMER_FILES_SUCCESS";
export const GET_CUSTOMER_FILES_FAIL = "GET_CUSTOMER_FILES_FAIL";

export const GET_CUSTOMER_FILE_START = "GET_CUSTOMER_FILE_START";
export const GET_CUSTOMER_FILE_SUCCESS = "GET_CUSTOMER_FILE_SUCCESS";
export const GET_CUSTOMER_FILE_FAIL = "GET_CUSTOMER_FILE_FAIL";

export const GET_PROMO_FILES_START = "GET_PROMO_FILES_START";
export const GET_PROMO_FILES_SUCCESS = "GET_PROMO_FILES_SUCCESS";
export const GET_PROMO_FILES_FAIL = "GET_PROMO_FILES_FAIL";

export const ARCHIVE_PROMOTION_START = "ARCHIVE_PROMOTION_START";
export const ARCHIVE_PROMOTION_SUCCESS = "ARCHIVE_PROMOTION_SUCCESS";
export const ARCHIVE_PROMOTION_FAIL = "ARCHIVE_PROMOTION_FAIL";

export const ARCHIVE_PARTNER_START = "ARCHIVE_PARTNER_START";
export const ARCHIVE_PARTNER_SUCCESS = "ARCHIVE_PARTNER_SUCCESS";
export const ARCHIVE_PARTNER_FAIL = "ARCHIVE_PARTNER_FAIL";

export const UNARCHIVE_PARTNER_START = "UNARCHIVE_PARTNER_START";
export const UNARCHIVE_PARTNER_SUCCESS = "UNARCHIVE_PARTNER_SUCCESS";
export const UNARCHIVE_PARTNER_FAIL = "UNARCHIVE_PARTNER_FAIL";

export const GET_PROMO_CODES_START = "GET_PROMO_CODES_START";
export const GET_PROMO_CODES_SUCCESS = "GET_PROMO_CODES_SUCCESS";
export const GET_PROMO_CODES_FAIL = "GET_PROMO_CODES_FAIL";

export const UPDATE_PARTNERS_POSITIONS_START = "UPDATE_PARTNERS_POSITIONS_START";
export const UPDATE_PARTNERS_POSITIONS_SUCCESS = "UPDATE_PARTNERS_POSITIONS_SUCCESS";
export const UPDATE_PARTNERS_POSITIONS_FAIL = "UPDATE_PARTNERS_POSITIONS_FAIL";

export const UPDATE_PROMOTIONS_POSITIONS_START = "UPDATE_PROMOTIONS_POSITIONS_START";
export const UPDATE_PROMOTIONS_POSITIONS_SUCCESS = "UPDATE_PROMOTIONS_POSITIONS_SUCCESS";
export const UPDATE_PROMOTIONS_POSITIONS_FAIL = "UPDATE_PROMOTIONS_POSITIONS_FAIL";
